// Icons
import { FaCircle } from 'react-icons/fa';
import { RiAlertFill } from 'react-icons/ri';

// Component imports
import SelectDataButton from '../../date-selector';

export function AccumulatedValue({
	sensor,
	accPeriod1,
	setAccPeriod1,
	accPeriod2,
	setAccPeriod2,
	accumulatedValue,
	STATUS_COLORS,
	statusColor,
}) {
	return (
		<div>
			{/* Seção do Hidrômetro */}
			<div className="last-data-container">
				<div style={{ width: '100%', display: 'flex', justifyContent: 'start' }}>
					<SelectDataButton
						periodo1={accPeriod1}
						setPeriodo1={setAccPeriod1}
						periodo2={accPeriod2}
						setPeriodo2={setAccPeriod2}
						hourlyData={true}
					/>
				</div>
				<div className="last-data-content-container">
					<div className="container-hidrometro">
						<div className="circle-hidrometro">
							<div className="inner-circle-hidrometro">
								<p>Valor Acumulado</p>
								<p className="value-hidrometro">
									{!isNaN(accumulatedValue) ? `${accumulatedValue.toFixed(1)} m³` : '-- m³'}
								</p>
								{sensor.alerta_superior > 0 &&
									(statusColor === STATUS_COLORS.ONLINE_NORMAL ? (
										<FaCircle
											style={{
												color: 'green',
												marginLeft: '8px',
												fontSize: '36px',
											}}
										/>
									) : statusColor === STATUS_COLORS.ONLINE_ALERT ? (
										<RiAlertFill
											style={{
												color: 'red',
												marginLeft: '8px',
												fontSize: '36px',
											}}
										/>
									) : (
										<FaCircle
											style={{
												color: 'gray',
												marginLeft: '8px',
												fontSize: '36px',
											}}
										/>
									))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
